import styles from '@/components/models/travel/PricingBlock/PricingBlockInfo/PricingBlockInfo.module.scss'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Card from 'react-bootstrap/Card'

interface Props {
  pricingTable: string
  priceCalculationInfo: string
}
const PricingBlockInfo = ({ pricingTable, priceCalculationInfo }: Props) => {
  return (
    <Col xl={5} className={styles.root}>
      <Card className={styles.prices}>
        <Row className={'m-0'}>
          <Col className={styles.inner}>
            <div className={styles.pricingTableWrap} dangerouslySetInnerHTML={{ __html: pricingTable }} />
            <div className={styles.pricingInfo}>{priceCalculationInfo}</div>
          </Col>
        </Row>
      </Card>
    </Col>
  )
}

export default PricingBlockInfo
